export default "__VITE_ASSET__59fZ_wOD__"